import { render, staticRenderFns } from "./DownloadFileShare.vue?vue&type=template&id=f648d5f0&"
import script from "./DownloadFileShare.vue?vue&type=script&lang=js&"
export * from "./DownloadFileShare.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/authen.css?vue&type=style&index=0&lang=css&"
import style1 from "./DownloadFileShare.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports